import { render, staticRenderFns } from "./EvalDocente.vue?vue&type=template&id=382653c2"
import script from "./EvalDocente.vue?vue&type=script&lang=js"
export * from "./EvalDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports